import {ModalWrapper} from "reoverlay";
import React, {useEffect, useState} from "react";
import ListItem from "../../ListItem";
import Button from "../../newComponents/button/Button";
import billTypes from "../../../tools/defaults/tosan/billTypes";
import {Swiper, SwiperSlide} from "swiper/react";
import SwiperCore, {Navigation,Pagination} from "swiper";
import 'swiper/swiper-bundle.min.css'
import 'swiper/swiper.min.css'

const BillDetailModal=({type,data,serviceType,onClose})=>{

    const [Info,setInfo]=useState([]);
    SwiperCore.use([Navigation,Pagination]);
    useEffect(()=>{
        if(data){
            const resultArray = convertObjectToArray(data);
            const filtered=resultArray.filter(item=>(item.value!=='' && item.value!==null))
            const newInfo=splitIntoChunks(filtered,4)

            setInfo(newInfo)
        }
    },[])
    function splitIntoChunks(array, chunkSize = 3) {

        let newArray = [];
        for (let i = 0; i < array.length; i += chunkSize) {
            let chunk = array.slice(i, i + chunkSize);
            newArray.push(chunk);
        }
        return newArray;
    }
    const convertObjectToArray = (obj) => {
        return Object.keys(obj).map(key => ({
            key: key,
            ...obj[key]
        }));
    };


    return <ModalWrapper animation="slideUp" contentContainerClassName="w-11/12 md:w-5/12  fixed w-full bottom-0 bg-gray-50 lg:w-4/12  rounded-t-lg" >
                <div className="pt-5">
                    <div className="w-full px-5 py-3   flex flex-col justify-center items-center  mb-2 border-b"><h1 className="font-black text-gray-800">{serviceType ? billTypes[serviceType].title : "جزییات قبض"}</h1></div>
                    <div className="w-full ">
                        <Swiper
                            // install Swiper modules
                            modules={[Navigation,Pagination]}
                            spaceBetween={0}
                            pagination={{ clickable: true }}
                            breakpoints={
                                {
                                    0: {
                                        slidesPerView: 1,
                                        spaceBetween: 3,
                                    },
                                    // when window width is >= 480px
                                    480: {
                                        slidesPerView: 1,
                                        spaceBetween: 3
                                    },
                                    // when window width is >= 640px
                                    640: {
                                        slidesPerView: 1,
                                        spaceBetween: 3
                                    }
                                }
                            }
                            navigation={{
                                nextEl: '.btn-next-swiper',
                                prevEl: '.btn-prev-swiper',
                            }}

                            direction="horizontal"
                            slidesPerView={1}
                        >

                            {
                                Info.map((array, index)=>{

                                    return <SwiperSlide className="pb-8" key={index+"item"}>{
                                        array.map((item,index)=>{

                                            return <ListItem className="w-full" value={item.value} title={item.faName} key={item.key}/>
                                        })
                                    }</SwiperSlide>
                                })
                            }
                        </Swiper>

                    </div>
                    <div className="grid px-5 py-2  border-t   grid-cols-1  gap-2">

                        <Button rounded="rounded-lg" onClick={onClose} theme="primary" >بستن</Button>
                    </div>
        </div>
          </ModalWrapper>
}
export default BillDetailModal;